var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close-btn",class:_vm.color,attrs:{"aria-label":"Close"},on:{"click":_vm.event}},[_c('span',{staticClass:"close-btn__icon",domProps:{"innerHTML":_vm._s(_vm.svgIcon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }